import { ToastContextDispatch } from "Context/CommonContext";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  getAPIRequest,
  putPostRequest,
} from "utilFunctions/Axios/AxiosRequestConfiguration";
import {
  BASE_URL,
  QUIZ,
  QUIZ_LIST,
} from "utilFunctions/Constants/urlConstants";

export const QuizContext = React.createContext<any>(null);
export const QuizContextProvider = (props: any) => {
  const { id } = useParams();
  const [quizData, setQuizData] = React.useState<any>([]);
  const [isDrawerOpen, setIsDrawerOpen] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isCreateMode, setIsCreateMode] = React.useState<boolean>(false);
  const [questions, setQuestions] = useState<any>([]);
  const [selectedQuestions, setSelectedQuestions] = useState<any>([]);
  const ToastDispatch = React.useContext(ToastContextDispatch);
  const [editableQuiz, setEditableQuiz] = useState({});
  const [refresh, setRefresh] = useState<any>(false);
  const [active, setActive] = useState<string>("1");
  const [isQuizEditable, setIsQuizEditable] = useState<boolean>(false);
  const [stepperForm, setStepperForm] = React.useState<any>({
    step1: {},
    step2: {},
  });
  const [generatedQuestion, setGeneratedQuestions] = useState({
    alreadySelected: [],
    autoPick: [],
    manualPick: [],
  });
  const [isCourseLoading, setIsCourseLoading] = React.useState<boolean>(false);
  const [maxQuestionLimit, setMaxQuestionLimit] = React.useState<number>(0);
  const [limit, setLimit] = React.useState<any>({
    quizQueLim: 0,
    lecQuizLim: 0,
  });
  const {
    alreadySelected = [],
    autoPick = [],
    manualPick = [],
  } = generatedQuestion || {};
  const AllQuestions = [...alreadySelected, ...autoPick, ...manualPick];
  const fetchMyScheduledData = async (url: string) => {
    const newURL = url + "?offset=0&limit=10";
    getAPIRequest({
      url: newURL,
      success: (res: any) => {
        const { data: response } = res || {};
        const { data: dataRes } = response || {};
        setQuizData(dataRes);
        setIsLoading(false);
      },
      failure: (err: any) => {
        console.log(err);
      },
    });
    setIsLoading(false);
  };
  const resetStates = () => {
    setIsCreateMode(false);
    setIsDrawerOpen(false);
    setStepperForm({
      step1: {},
      step2: {},
    });
    setQuestions([]);
    setSelectedQuestions([]);
    setRefresh(new Date().getTime());
    setActive("1");
    setGeneratedQuestions({
      alreadySelected: [],
      autoPick: [],
      manualPick: [],
    });
  };
  const fetchQuestions = async (url: string) => {
    getAPIRequest({
      url: url,
      success: (res: any) => {
        const { data: response } = res || {};
        const { data: dataRes, code, message } = response || {};
        if (code === "NF_RECORD") {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message: message,
          });
        }
        const newData = dataRes.map((question: any) => ({
          ...question,
          checked: true,
        }));
        const existingIds = new Set(AllQuestions.map((q: any) => q.questionId));
        const uniqueNewQuestions = newData.filter(
          (q: any) => !existingIds.has(q.questionId)
        );
        const alreadyAddedQuestions = (
          newData
            .filter((q: any) => existingIds.has(q.questionId))
            .map((ele: any) => ele.questionId) || []
        ).join(", ");
        if (alreadyAddedQuestions.length) {
          ToastDispatch({
            isOpen: true,
            type: "warning",
            message: `Already added questions: ${alreadyAddedQuestions}`,
          });
        }
        setSelectedQuestions(uniqueNewQuestions);
        setQuestions(uniqueNewQuestions);
        setIsLoading(false);
      },
      failure: (err: any) => {
        console.log(err);
      },
    });
    setIsLoading(false);
  };
  const fetchQuizById = async (url: string) => {
    getAPIRequest({
      url: url,
      success: (res: any) => {
        const { data: response } = res || {};
        const { data: dataRes, code, message } = response || {};
        const { questions } = dataRes || {};
        console.log("codecode", code);
        console.log("codecode", code, dataRes);
        if (code === "NF_RECORD") {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message: message,
          });
        }
        const quests = questions.map((question: any) => ({
          questionId: question.question_id,
          questionText: question?.text,
          questionType: question?.q_type,
          lod1: question?.lod1,
          checked: true,
        }));
        setGeneratedQuestions((prev: any) => ({
          ...prev,
          alreadySelected: quests,
        }));
        setSelectedQuestions(quests);
        setIsLoading(false);
      },
      failure: (err: any) => {
        console.log(err);
      },
    });
    setIsLoading(false);
  };
  const fetchQuizLimit = async (url: string) => {
    getAPIRequest({
      url: url,
      success: (res: any) => {
        const { data: response } = res || {};
        const { data: dataRes } = response || {};
        setLimit({
          quizQueLim: dataRes?.QUESTION_LIMIT_PER_QUIZ,
          lecQuizLim: dataRes?.QUIZ_LIMIT_PER_LECTURE,
        });
      },
      failure: (err: any) => {
        console.log(err);
      },
    });
    setIsLoading(false);
  };
  const onFinish = (cb?: any, editableId?: any) => {
    const { step1 } = stepperForm;
    const { quizTitle = "", courseId, streamId, subjectId } = step1 || {};

    const payload = {
      quizTitle: quizTitle,
      streamId: streamId,
      subjectId: subjectId,
      courseId: courseId,
      lectureId: id,
      qids: AllQuestions.map((ele: any) => ele.questionId),
    };
    // return;
    putPostRequest({
      url: editableId ? BASE_URL + QUIZ + "/" + editableId : BASE_URL + QUIZ,
      success: (res: any) => {
        const { data: dataRes } = res || {};
        resetStates();
        fetchMyScheduledData(BASE_URL + QUIZ_LIST + `/${id}`);
        const successMsg = editableId
          ? "Updated successfully"
          : "Created successfully";
        ToastDispatch({
          isOpen: true,
          type: "Success",
          message: successMsg,
        });
        cb(dataRes);
      },
      failure: (err: any) => {
        console.log(err);
      },
      body: payload,
      method: editableId ? "put" : "post",
    } as any);
  };
  return (
    <QuizContext.Provider
      value={{
        quizData,
        setQuizData,
        isDrawerOpen,
        setIsDrawerOpen,
        isLoading,
        fetchMyScheduledData,
        isCreateMode,
        setIsCreateMode,
        isCourseLoading,
        setIsCourseLoading,
        stepperForm,
        setStepperForm,
        onFinish,
        fetchQuestions,
        questions,
        selectedQuestions,
        setSelectedQuestions,
        editableQuiz,
        setEditableQuiz,
        setQuestions,
        fetchQuizById,
        refresh,
        active,
        setActive,
        generatedQuestion,
        setGeneratedQuestions,
        isQuizEditable,
        setIsQuizEditable,
        resetStates,
        maxQuestionLimit,
        setMaxQuestionLimit,
        fetchQuizLimit,
        limit,
      }}
    >
      {props.children}
    </QuizContext.Provider>
  );
};

export const useQuizContext = () => {
  const context = React.useContext(QuizContext);
  if (context === undefined) {
    throw new Error("useQuizContext must be used within a QuizContextProvider");
  }
  return context;
};
